import {ModalType} from "../../../Framework/Types/ModalTypes";
import Modal from "../../../Framework/Components/Modals/Modal";
import {ButtonSubmit} from "../../../Framework/Components/Buttons/Button";
import {ColourMod} from "../../../Framework/Data/Enums/LayoutEnums";
import {FieldValues, useForm} from "react-hook-form";
import {FormWrapperLabel} from "../../../Framework/Components/Forms/FormEntryWrapper/FormEntryWrapper";
import React, {useEffect, useState} from "react";
import EmailControl from "../../../Framework/Components/Forms/Email/EmailControl";
import {addUser, UsersUpdateType, useUpdateUsers} from "../../../Api/UsersEndpoints";
import AlertBanner from "../../../Framework/Components/AlertBanner/AlertBanner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFloppyDisk, faUser} from "@fortawesome/pro-solid-svg-icons";
import {useToasts} from "../../../Framework/Providers/ToastsProvider";

interface AddUserModalType extends ModalType {
    actionedCallback?: any;
}

const CreateUserModal = (props: AddUserModalType) => {
    const [emailControlActive, setEmailControlActive] = useState<boolean>(false);
    const [userSaving, setUserSaving] = useState<boolean>(false);

    const { addToast } = useToasts();

    const updateUsers = useUpdateUsers();

    const {
        register,
        handleSubmit,
        getValues,
        control,
        reset,
        setError,
        setFocus,
        clearErrors,
        formState: { errors, isValid },
    } = useForm({
        defaultValues: {
            name: '',
            emailAddress: ''
        }
    });

    const HandleCreate = (data: FieldValues, e: any) => {
        setUserSaving(true);

        addUser(data).then((r) => {
            updateUsers.mutate({
                updateType: UsersUpdateType.ADD,
                newData: r,
                forwardedFunction: null
            });

            if(props.actionedCallback) {
                props.actionedCallback(r.userId);
            }

            addToast('User Created!', <FontAwesomeIcon icon={faUser} />, ColourMod.Success);
            props.closeCallback();
        }).catch((e) => {
            console.error(e.response.data);
        }).finally(() => setUserSaving(false))
    }

    useEffect(() => {
        setFocus('name');
        return () => reset();
    }, [props.visible]);

    return (
		<Modal title={'New User'} isOpen={props.visible} closeCallback={() => props.closeCallback()}>
			<form onSubmit={handleSubmit((data, e) => HandleCreate(data, e))}>
				<fieldset className={'flex-column flex-gap-md'}>
					<AlertBanner
						title={'An email will be sent to this user so they can set their own account password'}
					/>

					<FormWrapperLabel
						label={'Name'}
						value={getValues().name}
						invalid={errors.name ? true : null}
						validationMessage={errors.name?.message as string}
					>
						<input
							type='text'
							aria-invalid={errors.name ? 'true' : 'false'}
							{...register('name', {
								required: 'This is a required field',
								minLength: { value: 2, message: 'Too short' },
							})}
						/>
					</FormWrapperLabel>

					<EmailControl
						control={control}
						name={'emailAddress'}
						invalid={errors.emailAddress && errors.emailAddress?.message !== ''}
						validationMessage={errors.emailAddress?.message as string}
						forwardBlocker={(e: boolean) => setEmailControlActive(e)}
						setError={setError}
						clearErrors={clearErrors}
						checkUnique={true}
					/>

					<ButtonSubmit
						loading={userSaving}
						disabled={Object.keys(errors).length > 0 || !isValid || emailControlActive}
						title={'Create User'}
						fullWidth={true}
						colour={ColourMod.Primary}
					/>
				</fieldset>
			</form>
		</Modal>
	);
}

export default CreateUserModal